import { useCallback, useState } from "react";
import useMergeState from "../useMergeState";
import apiMethods from "../../../utils/api";

const useMutation = (method: string, url: string) => {
    const [state, mergeState] = useMergeState({
        data: null,
        error: null,
        isWorking: false,
    });
    const [currentUrl, setCurrentUrl] = useState(url);

    const makeRequest = useCallback(
        (variables = {}) =>
            new Promise((resolve, reject) => {
                mergeState({ isWorking: true });

                (apiMethods as any)[method](currentUrl, variables).then(
                    (data: any) => {
                        resolve(data);
                        mergeState({ data, error: null, isWorking: false });
                    },
                    (error: any) => {
                        reject(error);
                        mergeState({ error, data: null, isWorking: false });
                    }
                );
            }),
        [method, currentUrl, mergeState]
    );

    const setLocalUrl = (newUrl: string) => {
        setCurrentUrl(newUrl);
    };

    return [
        {
            ...state,
            setLocalUrl,
            [isWorkingAlias[method]]: state.isWorking,
        },
        makeRequest,
    ];
};

const isWorkingAlias: { [key: string]: any } = {
    post: "isCreating",
    put: "isUpdating",
    patch: "isUpdating",
    delete: "isDeleting",
};

export default useMutation;
